/**
 * Camp-pickup v1 T4 — "Peek their brief": who is this companion and what
 * did I send them to do. Read-only, anchored to the (relative) camp
 * marker, api-free by construction: identity enriches from the already-
 * hydrated CouncilContext.state.personasById (null-guarded — renders
 * name + task without it), the brief is the camp's own task string.
 * (The spec named WakeBriefCard, which doesn't exist — useWakeBrief is a
 * session-scoped away-digest, wrong semantics for a per-camp peek.)
 */
import React, { useContext } from 'react';
import { CouncilContext } from '../../../../contexts/CouncilContext';

export function CampBriefPopover({ personaId, personaName, task, arrivalState, turnFailedReason, onClose }: {
  personaId: string;
  personaName: string;
  task?: string;
  arrivalState: string;
  turnFailedReason?: string;
  onClose: () => void;
}) {
  const council = useContext(CouncilContext); // null-safe: identity enrichment only
  const persona = council?.state?.personasById?.[personaId];
  return (
    <div data-testid={`camp-brief-${personaId}`}
      className="nodrag absolute z-50 top-full left-0 mt-1 w-64 rounded-md border shadow-lg p-3 text-xs bg-white border-gray-200 text-gray-800 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100">
      <div className="flex items-start justify-between gap-2">
        <div className="font-semibold truncate">{personaName}</div>
        <button type="button" data-testid={`camp-brief-close-${personaId}`} aria-label="Close brief"
          onClick={onClose} className="px-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700">×</button>
      </div>
      {persona?.shortDescription && <p className="mt-1 opacity-80">{persona.shortDescription}</p>}
      <div className="mt-2">
        <div className="uppercase tracking-wide opacity-60 text-[10px]">Their brief</div>
        <p data-testid={`camp-brief-task-${personaId}`} className="mt-0.5">
          {task || 'No brief recorded — they joined without a task.'}
        </p>
      </div>
      {arrivalState === 'failed' && turnFailedReason && (
        <p className="mt-2 text-red-600 dark:text-red-400">Last attempt failed: {turnFailedReason}</p>
      )}
    </div>
  );
}
